export enum RedirectType {
  href = 'href',
  replace = 'replace',
}
